import AccordionsGroup from './AccordionsGroup'
import Accordion from './Accordion'

export default {
  accordions_group: AccordionsGroup,
  accordion: Accordion,
}
